/* eslint-disable @typescript-eslint/naming-convention */
export const STATUS_COLOR = {
  red: '#FF0606',
  orange: '#FF8B06',
  black: '#333333',
};

export const SEND_TARGET_COLOR = {
  blue: '#428FB0',
  yellow: '#B08442',
  green: '#86B042',
  purple: '#7242B0',
  red: '#B04242'
};

export const NOTIFICATIONS_STATUS = {
  0: {
    name: 'STATUS.TEST_SEND',
    color: STATUS_COLOR.orange,
  },
  1: {
    name: 'STATUS.SENT',
    color: STATUS_COLOR.red,
  },
};

export const SEND_TARGET = {
  0: {
    name: 'SEND_TARGET.SYS_ADMIN',
    color: SEND_TARGET_COLOR.blue,
    roleId: 99,
  },
  1: {
    name: 'SEND_TARGET.STAFF',
    color: SEND_TARGET_COLOR.yellow,
    roleId: 2,
  },
  2: {
    name: 'SEND_TARGET.USER',
    color: SEND_TARGET_COLOR.red,
    roleId: 1,
  },
  3: {
    name: 'SEND_TARGET.RELATIVE',
    color: SEND_TARGET_COLOR.green,
    roleId: 3,
  },
  4: {
    name: 'SEND_TARGET.PARTICIPANT',
    color: SEND_TARGET_COLOR.purple,
    roleId: 4,
  },
};

export const NOTIFICATIONS_DETAIL_STATUS = {
  0: {
    name: 'STATUS.SEND_FAILED',
    color: STATUS_COLOR.red,
    searchKey: '失敗',
  },
  1: {
    name: 'STATUS.RECEIVE',
    color: STATUS_COLOR.black,
    searchKey: '成功',
  },
};
